<template>
  <span class="link" @click="handleReset">
    <i class="far fa-lock-keyhole" />
    Reset Password
  </span>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  methods: {
    ...mapActions(["sendPasswordReset"]),
    handleReset() {
      this.sendPasswordReset(this.customer);
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-divider {
  border-bottom: 1px solid var(--gray-border-color);
  width: 100%;
  margin: 2px 0;
}
</style>
